import {
    Descendant,
} from 'slate';

import AudioNoteElement from '../components/Editor/elements/audioNoteElement';
import { AudioNoteNode } from '../components/Editor/interfaces';
import {
    IPostContentDictationSourceTextsByAudioNoteId,
    IResolvePostContentDictationSourceTextsByAudioNoteIdArgs,
} from '../interfaces/IResolvePostContentDictationSourceTextsByAudioNoteIdArgs';
import serializeSlatePlainText from './serializeSlatePlainText';

/**
 * Post dictation notes should align to the body content that follows that note
 * instead of the entire visible chapter or section scope.
 */
function resolvePostContentDictationSourceTextsByAudioNoteId({
    slateValue,
    includeNonDictationAudioNotes = false,
}: IResolvePostContentDictationSourceTextsByAudioNoteIdArgs): IPostContentDictationSourceTextsByAudioNoteId {
    const safeSlateValue = Array.isArray(slateValue)
        ? slateValue
        : [];
    const sourceTextsByAudioNoteId: IPostContentDictationSourceTextsByAudioNoteId = {};

    const isPostContentDictationAudioNote = (node: Descendant): node is AudioNoteNode => (
        AudioNoteElement.isAudioNoteElement(node)
        && (node as AudioNoteNode).isPostContentDictation === true
    );

    safeSlateValue.forEach((node, index) => {
        if (!AudioNoteElement.isAudioNoteElement(node)) {
            return;
        }

        if (!includeNonDictationAudioNotes && !isPostContentDictationAudioNote(node)) {
            return;
        }

        const audioNoteNode = node as AudioNoteNode;

        let nextPostContentDictationIndex = safeSlateValue.length;

        for (let cursor = index + 1; cursor < safeSlateValue.length; cursor += 1) {
            if (isPostContentDictationAudioNote(safeSlateValue[cursor])) {
                nextPostContentDictationIndex = cursor;
                break;
            }
        }

        sourceTextsByAudioNoteId[audioNoteNode.id] = serializeSlatePlainText({
            slateValue: safeSlateValue.slice(index + 1, nextPostContentDictationIndex),
            excludeFigureCaptions: true,
            includeSectionHeadingPrefixes: true,
        });
    });

    return sourceTextsByAudioNoteId;
}

export default resolvePostContentDictationSourceTextsByAudioNoteId;
